<template>
  <div>
    <div class="rbox">
      <head-text  :kpi="activeKpi" 
                  :isSmall="true"
                  fallbackText="Process Excellence" />
      <item       :thresholdData="threshold" 
                  :round="true" 
                  :isSmall="true"
                  :kpi="activeKpi" />
    </div>
  </div>
</template>

<script>

import HeadText from './KpiHeader.vue';
import Item from './KpiItem.vue';

export default {
  props: {
    dashboardData: Object,
    threshold: Array,
    actualTimeSetting: String,
    showPerformanceIndex: Boolean
  },

  components: {
    HeadText, Item
  },

  data () {
    return {
      kpi: null,
      kpiYTD: null
    };
  },

  mounted() {
    this.kpi = this.getKpi(false);
    this.kpiYTD = this.getKpi(true);
  },

  computed:{
    ScoreName() {
      return this.activeKpi()?.NameShort || this.$t('Webportal.CX.BMW.NotAvailable');
    },
    ScoreText() {
      return this.formatResult(this.activeKpi()?.Result);
    },
    ScoreNumeric() {
      return this.activeKpi()?.Result || 0;
    },
    activeKpi() {
      return this.actualTimeSetting === 'current' ? this.kpi : this.kpiYTD;
    },
  },

  methods: {
    getKpi(useYTD) {
      let root = this.dashboardData.KPI[useYTD ? 'KPIGroupYTD' : 'KPIGroup'];
      
      if (!this.showPerformanceIndex) {
        return {
          NameShort: this.$t('Webportal.CX.BMW.CxScoreNameLong'),
          Result: this.dashboardData.CXScore || undefined
        };
      }

      let kpi = root.find(x => x.Code == 'Customer Experience Check-up');
      if (kpi) {
        return kpi;
      }

      kpi = root.find(x => x.Code == 'Process Excellence');
      if (kpi) {
        return kpi;
      }

      return null;
    },

    formatResult(res) {
      return (!res && res !== 0) ? this.$t('Webportal.CX.BMW.NotAvailable') : `${Math.round(res)}%`;
    },

    getColor(value) {
      return this.threshold.find(
        thres => thres.Minimum <= value && thres.Maximum >= value
      )?.Color;
    }
  }
}
</script>

<style lang="scss" scoped>
.rbox {
  max-width: 13.25rem;
  margin-left: auto; 
  margin-right: 0;
}
</style>